<div class="report-container retail-rental warehouse-rentalv2">

    <ng-container>

        <app-report-sub-menu [menuList]="overViewMenu"
            (menuChangeValue)="menuChangeValue($event)"></app-report-sub-menu>
        <div class="report-tabsection" id="{{ warehouseRentalMenuEnum.overview}}"
            [ngClass]="{ 'scroll': currentScroll === warehouseRentalMenuEnum.overview}">
            <div class="report-overview report-overview-2col">
                <ng-container *ngIf="overViewLoading">
                    <app-skeleton-loader [reportType]="chartView.overView" [loaderSize]="1" [height]="'150px'"></app-skeleton-loader>
                </ng-container>
                <ng-container *ngIf="!overViewLoading">
                    <!-- ttm commented code [minDate]="overViewAverageSummary?.min_date"
                [maxDate]="overViewAverageSummary?.max_date"  -->
                        <app-overview-card
                [card_title]="sharedService.priceCalculation$() === sharedService.priceYearly ? 'reports.annualAverageRentRateGradeWise':'reports.averageRentRateGradeWise'"
                [uniType]="UnitTypeEnum.currencywithsqm" [propertiesCount]="overViewAverageSummary?.total_properties"
                [graphData]="{data: overviewAverageRate, type: 'averageRentRate'}"
                [untillDate]="overViewAverageSummary?.untillDate"
                [minDate]="overViewAverageSummary?.min_date"
                [maxDate]="overViewAverageSummary?.max_date"
                [gradeWise]="true"></app-overview-card>
                </ng-container>
                <ng-container *ngIf="overViewNeighborhoodsLoading">
                    <app-skeleton-loader [reportType]="chartView.overView" [loaderSize]="1" [height]="'150px'"></app-skeleton-loader>
                </ng-container>
                <ng-container *ngIf="!overViewNeighborhoodsLoading">
                    <app-overview-card [card_title]="'reports.topNeighborhoods'"
                        [BasedOnRentalsText]="true" [rentalsName]="basedOnCategory"
                        [total_current]="overViewNeighborhoodSummary.avg_rent"
                        [uniType]="UnitTypeEnum.currencywithsqm"
                        [graphData]="{data: overviewNeighborhoodRate, type: 'occupancyRate'}"
                        [untillDate]="overViewNeighborhoodSummary?.untillDate"
                        [minDate]="overViewNeighborhoodSummary?.min_date"
                        [maxDate]="overViewNeighborhoodSummary?.max_date"
                        ></app-overview-card>
                </ng-container>
            </div>
            <div class="report-model report-rentrate">
                <div class="report-model-header">
                    <div class="info">
                        <h3>{{sharedService.priceCalculation$() === sharedService.priceYearly ?
                            ('reports.annual_rental_price_in' | translate) : ('reports.rental_price_in' | translate)}}
                            <span class="text-capitalize">{{(placeName | lowercase) | translate}}</span>
                            <!-- {{'reports.past_years' | translate}} --> ({{CurrencyCode |
                            translate}}/{{'reports.sqm_unit' | translate}})
                        </h3>
                    </div>
                    <button class="btn-select-grade" [matMenuTriggerFor]="menu"
                        *ngIf="!retailRentalChartLoading && (retailRentalChartReport | json) != '{}' && (retailRentalChartReport | json) != '[]'">
                        <div class="setext">
                            <ng-container *ngFor="let name of selectedChartValue; let l = last">{{name}}<span *ngIf="!l"
                                    style="padding-right: 2px;">,</span></ng-container>
                        </div>
                        <span class="morecount" *ngIf="selectedChartValue.length > 1">{{moreText}}</span>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </button>

                    <mat-menu #menu="matMenu" [xPosition]="langName === 'ar' ? 'after' : 'before'"
                        class="grades-menu directionLtr">
                        <div (click)="$event.stopPropagation()">
                            <h5>{{'reports.choose_maximum_options' | translate}}</h5>
                            <ng-container *ngFor="let category of getReportKeys()">
                                <mat-checkbox (change)="selectChart($event, category)"
                                    [checked]="selectedChartValue.includes(category)">{{category}}</mat-checkbox>
                            </ng-container>
                        </div>
                    </mat-menu>



                </div>
                <ng-container *ngIf="retailRentalChartLoading">
                    <app-skeleton-loader [reportType]="chartView.barChart"></app-skeleton-loader>
                </ng-container>
                <ng-container *ngIf="!retailRentalChartLoading">
                    <div class="multiBarChart d-flex"
                    *ngIf="(retailRentalChartReport | json) != '{}' && (retailRentalChartReport | json) != '[]'; else noDataMessage">
                        <ng-container *ngFor="let chart of retailRentalChartReport | keyvalue; let i = index">
                            <app-report-charts class="grchart" [data]="chart.value"
                                [chartType]="chartView.smallBarChart" [isBorder]="false" [name]="chart.key" [index]="i"
                                [ngStyle]="{'min-width': (retailRentalChartReport | keyvalue).length == 1 ? '100%' : '300px'}">
                            </app-report-charts>
                        </ng-container>


                    </div>
                    <ng-template #noDataMessage>
                        <div class="data_unavail">
                            <span>
                                {{"reports.data_not_available" | translate}} <mat-icon role="img"
                                    class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color"
                                    aria-hidden="true" data-mat-icon-type="font">equalizer</mat-icon>
                            </span>
                        </div>
                    </ng-template>
                </ng-container>
            </div>
        </div>

        <!-- Rental Unit Size Table -->
        <div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === warehouseRentalMenuEnum.retailUnitSize}"
            id="{{ warehouseRentalMenuEnum.retailUnitSize }}">
            <app-report-year-dropdown [reportType]="'rentalUnit'"
                (selectedYear)="selectedYear($event)"></app-report-year-dropdown>
            <div class="report-model">
                <app-datatable-title [isShowCount]="false" [title]=" sharedService.priceCalculation$() === sharedService.priceYearly ? 'reports.annualRentUnitSizeWise' : 'reports.rentUnitSizeWise' " [count]="retailUnitsizeCount" [countTitle]="'reports.totalUnits'"></app-datatable-title>

                <app-warehouse-rental-unit-size
                    [showLoader]="!warehouseUnitsizeLoading"
                    [tableColumns]="warehouseUnitsizeColumns"
                    [tableData]="warehouseUnitsizedata"
                    (pageEvent)="onPageEvent($event, warehouseRentalMenuEnum.retailUnitSize)"
                    (sort)="sortData($event, warehouseRentalMenuEnum.retailUnitSize)" [allowExcelDownload]="true"
                    (excelDownload)="downloadExcel($event, 'warehouse_rental_unitsize_v2', 'a')"
                    [downloadLoading]="downloadLoading['a']" [showEstaterText]="true"
                    [dropDownOption]="unitSizeDropdown"
                    ></app-warehouse-rental-unit-size>

            </div>
        </div>

        <!-- Project table -->
        <!-- <div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === warehouseRentalMenuEnum.project}"
            id="{{ warehouseRentalMenuEnum.project }}">

            <app-report-year-dropdown [reportType]="'unit'"
                (selectedYear)="selectedYear($event)"></app-report-year-dropdown>
            <div class="report-model">
                <app-datatable-title [title]="'reports.project'" [count]="retailUnitCount" [countTitle]="'reports.totalProjects'"></app-datatable-title>


                <app-warehouse-rental-property
                    [showLoader]="!retailUnitLoading"
                    [ngClass]="{'activeTable': tableName == warehouseRentalMenuEnum.project}"
                    (lastClickedTable)="lastClickedTable($event, warehouseRentalMenuEnum.project)"
                    [tableColumns]="warehousePropertiesColumns" [dataLength]="retailUnitCount"
                    [tableData]="retailUnitdata" (pageEvent)="onPageEvent($event, warehouseRentalMenuEnum.project)"
                    [allowExcelDownload]="true"
                    (excelDownload)="downloadExcel($event, 'warehouse_rental_projects_v2', 'b')"
                    [downloadLoading]="downloadLoading['b']" [showEstaterText]="true"
                    [dropDownOption]="propertiesDropdown"
                    >

                </app-warehouse-rental-property>

            </div>
        </div> -->

        <div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === warehouseRentalMenuEnum.property}"
            id="{{ warehouseRentalMenuEnum.property }}">

            <app-report-year-dropdown [reportType]="'unit'"
                (selectedYear)="selectedYear($event)"></app-report-year-dropdown>
            <div class="report-model">
                <app-datatable-title [title]="'reports.projectsProperties'" [count]="retailPropertyCount" [countTitle]="'reports.totalProperties'"></app-datatable-title>


                <app-warehouse-rental-property
                    [showLoader]="!retailPropertyLoading"
                    [ngClass]="{'activeTable': tableName == warehouseRentalMenuEnum.property}"
                    (lastClickedTable)="lastClickedTable($event, warehouseRentalMenuEnum.property)"
                    [tableColumns]="warehousePropertiesColumns"
                    [dataLength]="retailPropertyCount"
                    [tableData]="retailPropertydata"
                    (pageEvent)="onPageEvent($event, warehouseRentalMenuEnum.property)"
                    [allowExcelDownload]="true"
                    (excelDownload)="downloadExcel($event, 'warehouse_rental_property_new_v2', 'b')"
                    [downloadLoading]="downloadLoading['b']"
                    [showEstaterText]="true"
                    [dropDownOption]="propertiesDropdown"
                    >

                </app-warehouse-rental-property>

            </div>
        </div>

    </ng-container>

</div>
